export default __webpack_public_path__ + "112201b638d9471224271ecb3a297d9c.jpg";